import { AutonomousActivityType } from "protos/atk/enums";
import { CHIP_COLORS } from "portal/theme/theme";
import { RadioChips } from "../RadioChips";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import React from "react";

interface AutonomousActivitySwitcherProps {
  variant?: "default" | "with-descriptions";
  activeActivity: AutonomousActivityType;
  setActiveActivity: (activity: AutonomousActivityType) => void;
}

const activityDescriptions: {
  [activityType in AutonomousActivityType]?: { i18nKey: string };
} = {
  [AutonomousActivityType.ACTIVITY_WORKING_ROW]: {
    i18nKey:
      "views.autotractor.autonomousActivities.activities.workingRowsDescription",
  },
  [AutonomousActivityType.ACTIVITY_WORKING_HEADLAND]: {
    i18nKey:
      "views.autotractor.autonomousActivities.activities.workingHeadlandsDescription",
  },
  [AutonomousActivityType.ACTIVITY_EORTA]: {
    i18nKey:
      "views.autotractor.autonomousActivities.activities.eortasDescription",
  },
  [AutonomousActivityType.ACTIVITY_WORKING_DIVERT]: {
    i18nKey:
      "views.autotractor.autonomousActivities.activities.workingDivertsDescription",
  },
};

export const AutonomousActivitySwitcher: React.FC<
  AutonomousActivitySwitcherProps
> = ({ activeActivity, setActiveActivity, variant = "default" }) => {
  const { t } = useTranslation();

  return (
    <>
      <RadioChips
        isLoading={false}
        activeId={activeActivity.toString()}
        setActiveId={(activeId) => setActiveActivity(Number.parseInt(activeId))}
        options={[
          {
            id: AutonomousActivityType.ACTIVITY_WORKING_ROW.toString(),
            name: t(
              "views.autotractor.autonomousActivities.activities.workingRows"
            ),
            color: CHIP_COLORS[0],
          },
          {
            id: AutonomousActivityType.ACTIVITY_WORKING_HEADLAND.toString(),
            name: t(
              "views.autotractor.autonomousActivities.activities.workingHeadlands"
            ),
            color: CHIP_COLORS[1],
          },
          {
            id: AutonomousActivityType.ACTIVITY_EORTA.toString(),
            name: t("views.autotractor.autonomousActivities.activities.eortas"),
            color: CHIP_COLORS[2],
          },
          {
            id: AutonomousActivityType.ACTIVITY_WORKING_DIVERT.toString(),
            name: t(
              "views.autotractor.autonomousActivities.activities.workingDiverts"
            ),
            color: CHIP_COLORS[3],
          },
        ]}
        className="col-span-full"
      />
      {variant === "with-descriptions" && (
        <Typography variant="body2" className="col-span-full">
          {activityDescriptions[activeActivity]?.i18nKey
            ? t(activityDescriptions[activeActivity].i18nKey)
            : undefined}
        </Typography>
      )}
    </>
  );
};
